import { registerSilentReauthHandler } from "../shared/auth/silentReauth";
import { reauthSilently } from "../shared/auth/authService";
import { registerAuthHostServices } from "../shared/auth/authHostServices";
import { registerFactSetOAuthReconnectHandler } from "../shared/factset/factsetReconnect";
import { setStorageUserScope } from "../powerpoint/services/storageService";
import { initFeatureFlags, disposeFeatureFlags } from "../powerpoint/services/featureFlagService";
import {
  ensureFactSetOAuthConnected,
  forceReconnectFactSetOAuth,
} from "../powerpoint/services/factset/factsetOAuthService";

let registered = false;

export function registerTaskpaneHostServices(): void {
  if (registered) return;

  registerSilentReauthHandler(reauthSilently);
  registerFactSetOAuthReconnectHandler(forceReconnectFactSetOAuth);
  registerAuthHostServices({
    setUserScope: setStorageUserScope,
    initFeatureFlags,
    disposeFeatureFlags,
    ensureFactSetOAuthConnected,
  });
  registered = true;
}
